import React, { Fragment } from 'react';
import { filter } from 'lodash';
import enhance from './CompanyMatchFeed.enhancer';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import NativeSelectInput from '../../../components/shared/components/NativeSelectInput';
import BootstrapInput from '../../shared/components/OutlinedInputBox';
import { dealStatuses } from '../../../constants';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import LinkText from '../../shared/components/LinkText';

class CompanyOfferFeed extends React.Component {
  constructor() {
    super();

    this.viewStates = {
      RECIEVED: 'RECIEVED',
      SENT: 'SENT'
    };

    this.initialState = {
      matchOffers: [],
      tableRows: [],
      currentPage: 0,
      currentCount: 0,
      rowsLoaded: false,
      tableView: this.viewStates.RECIEVED,
      viewStates: [
        {
          key: this.viewStates.RECIEVED,
          value: `Matches I've received`
        },
        {
          key: this.viewStates.SENT,
          value: `Matches I've sent`
        }
      ],
      campaignsLoaded: false,
      hasCampaign: false
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillMount() {
    if (this.props.matchesPending) {
      if (this.props.matchesPending.length) {
        this.loadData(this.props.matchesPending);
      } else {
        this.setState({
          tableRows: [],
          rowsLoaded: true
        });
      }
    }
    if (this.props.campaignsLoaded) {
      this.setState({
        campaignsLoaded: true
      });
      if (this.props.campaignsCount) {
        this.setState({
          hasCampaign: true
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.matchesPending) {
      if (nextProps.matchesPending.length) {
        this.loadData(nextProps.matchesPending);
      } else {
        this.setState({
          tableRows: [],
          rowsLoaded: true
        });
      }
    }
    if (this.props.campaignsLoaded) {
      this.setState({
        campaignsLoaded: true
      });
      if (this.props.campaignsCount) {
        this.setState({
          hasCampaign: true
        });
      }
    }
  }

  loadData(pendingMatches) {
    const offeredDeals = filter(
      pendingMatches,
      mp => mp.status === dealStatuses.OFFER
    );
    let requests = offeredDeals.map(deal => {
      return new Promise(resolve => {
        //get user data
        this.props.firestore
          .get({
            collection: 'users',
            doc: deal.influencerId
          })
          .then(user => {
            if (user && deal.influencerId) {
              const userData = user.data();
              if (userData) {
                deal.influencerName = userData.displayName;
                deal.influencerSubscribers = userData.youtube
                  ? userData.youtube.subscribers.toLocaleString()
                  : 0;
                deal.influencerAverageViews = userData.youtube
                  ? userData.youtube.averageViews.toLocaleString()
                  : 0;
                deal.picUrl = userData.profilePictureUrl;
                deal.influencerId = user.id;
              }
            }

            //get campaign data
            this.props.firestore
              .get({
                collection: 'campaigns',
                storeAs: 'matchFeedCampaign',
                doc: deal.campaignId
              })
              .then(camp => {
                if (camp && deal.campaignId) {
                  const campData = camp.data();
                  if (campData) {
                    deal.campaign = campData;
                  }
                }
                resolve(deal);
              });
          });
      });
    });

    Promise.all(requests).then(deals => {
      this.setState({
        matchOffers: deals
      });
      this.filterDeals(this.state.tableView);
    });
  }

  filterDeals(tableState) {
    const filteredOffers = filter(this.state.matchOffers, offer =>
      tableState === 'RECIEVED'
        ? offer.initiator === 'influencer'
        : offer.initiator === 'company'
    );

    this.setState({
      tableRows: filteredOffers,
      rowsLoaded: true
    });
  }

  viewSelectChangeHandler(e) {
    this.setState(
      {
        tableView: e.target.value
      },
      this.filterDeals(e.target.value)
    );
  }

  acceptMatch(row) {
    const acceptedMatch = {
      deal: row,
      initiator: this.props.auth.uid
    };
    this.props.acceptMatchHandler(acceptedMatch);
  }

  rejectMatch(row) {
    const rejectedMatch = {
      deal: row,
      initiator: row.influencerId
    };
    this.props.rejectMatchHandler(rejectedMatch);
  }

  navigateToCampaign(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  navigateToProfile(userId) {
    this.props.history.push(`/user/${userId}/profile`);
  }

  navigateToDiscoverInfluencers() {
    this.props.history.push(`discover-influencers`);
  }

  navigateToCreateCampaign() {
    this.props.history.push(`campaign/new`);
  }

  render() {
    const { classes } = this.props;
    const {
      tableRows,
      rowsLoaded,
      tableView,
      viewStates,
      campaignsLoaded,
      hasCampaign
    } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <div className={classes.title}>
            <Typography variant="h3" id="tableTitle" className={classes.title}>
              Match Feed
            </Typography>
          </div>
          <div>
            <TextField
              id="viewSelect"
              name="viewSelect"
              select
              className={classes.select}
              SelectProps={{
                MenuProps: {
                  className: classes.selectMenu
                }
              }}
              margin="normal"
              variant="outlined"
              onChange={this.viewSelectChangeHandler.bind(this)}
              value={tableView}
            >
              {viewStates.map((item, i) => (
                <MenuItem key={i} value={item.key}>
                  {item.value}
                </MenuItem>
              ))}
            </TextField>
          </div>
          {tableRows &&
            rowsLoaded &&
            tableRows.map(row => (
              <Paper className={classes.root}>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item sm={4} container alignItems="center">
                    <img src={row.picUrl} className={classes.circleImage} />
                    <div className={classes.influencerName}>
                      <LinkText
                        variant="h6"
                        onClick={() => this.navigateToProfile(row.influencerId)}
                      >
                        {row.influencerName}
                      </LinkText>
                      <Typography>
                        Subscribers: {row.influencerSubscribers}
                      </Typography>
                      <Typography>
                        Average Views: {row.influencerAverageViews}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item sm={4}>
                    <LinkText
                      variant="h6"
                      className={classes.linkStyle}
                      onClick={() => this.navigateToCampaign(row.campaignId)}
                    >
                      {row.campaign.name}
                    </LinkText>
                  </Grid>
                  <Grid
                    item
                    sm={4}
                    container
                    alignItems="center"
                    justify="flex-end"
                    spacing={2}
                  >
                    {tableView === 'RECIEVED' && (
                      <Fragment>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.acceptButton}
                            onClick={() => this.acceptMatch(row)}
                          >
                            Accept
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="outlined"
                            color="secondary"
                            className={classes.rejectButton}
                            onClick={() => this.rejectMatch(row)}
                          >
                            Reject
                          </Button>
                        </Grid>
                      </Fragment>
                    )}
                    {tableView === 'SENT' && (
                      <div>
                        <Button color="primary" variant="outlined">
                          Pending
                        </Button>
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            ))}
          {!tableRows.length && rowsLoaded && campaignsLoaded && !hasCampaign && (
            <Paper className={classes.root} className={classes.noCurrentOffers}>
              <Grid container direction="row" justify="center">
                <Grid
                  container
                  alignItems="center"
                  sm={12}
                  justify="center"
                  className={classes.noOffersContainer}
                >
                  <Typography
                    variant="h6"
                    align="center"
                    justify="center"
                    className={classes.noCampText}
                  >
                    No current offers -{' '}
                    <LinkText
                      className={classes.createCampLink}
                      onClick={() => this.navigateToCreateCampaign()}
                    >
                      Create a Campaign{' '}
                    </LinkText>
                    to start getting offers
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          )}
          {!tableRows.length && rowsLoaded && campaignsLoaded && hasCampaign && (
            <Paper className={classes.root} className={classes.noCurrentOffers}>
              <Grid container direction="row" justify="center">
                <Grid
                  container
                  alignItems="center"
                  sm={12}
                  justify="center"
                  className={classes.noOffersContainer}
                >
                  <Typography
                    variant="h6"
                    align="center"
                    justify="center"
                    className={classes.noCampText}
                  >
                    No current offers -{' '}
                    <LinkText
                      className={classes.createCampLink}
                      onClick={() => this.navigateToDiscoverInfluencers()}
                    >
                      Discover Influencers{' '}
                    </LinkText>
                    to get new matches
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          )}
        </main>
      </React.Fragment>
    );
  }
}

CompanyOfferFeed.propTypes = {
  matchOffers: PropTypes.array
};

export default enhance(CompanyOfferFeed);



// WEBPACK FOOTER //
// ./src/components/company/match-feed/CompanyMatchFeed.js